/** Public RSS directory worker origin (production). */
export const LUCIMARK_FEEDS_API_PUBLIC_ORIGIN = 'https://feeds.lucimark.com'
